var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1642_3272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12.5C15 16.6421 11.6421 20 7.5 20C3.35786 20 0 16.6421 0 12.5C0 8.35786 3.35786 5 7.5 5C11.6421 5 15 8.35786 15 12.5ZM7.5 8.5C6.97471 8.5 6.45457 8.60346 5.96927 8.80448C5.48396 9.0055 5.04301 9.30014 4.67157 9.67157C4.30014 10.043 4.0055 10.484 3.80448 10.9693C3.60346 11.4546 3.5 11.9747 3.5 12.5C3.5 12.9142 3.16421 13.25 2.75 13.25C2.33579 13.25 2 12.9142 2 12.5C2 11.7777 2.14226 11.0625 2.41866 10.3952C2.69506 9.72795 3.10019 9.12164 3.61091 8.61091C4.12163 8.10019 4.72795 7.69506 5.39524 7.41866C6.06253 7.14226 6.77773 7 7.5 7C7.91421 7 8.25 7.33579 8.25 7.75C8.25 8.16421 7.91421 8.5 7.5 8.5ZM10.9641 10.5C11.3152 11.1081 11.5 11.7979 11.5 12.5C11.5 12.9142 11.8358 13.25 12.25 13.25C12.6642 13.25 13 12.9142 13 12.5C13 11.5345 12.7459 10.5861 12.2631 9.75C12.056 9.39128 11.5973 9.26837 11.2386 9.47548C10.8799 9.68259 10.757 10.1413 10.9641 10.5Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9602 11.6725C18.3114 10.8601 20 8.62727 20 6C20 2.68629 17.3137 0 14 0C11.3727 0 9.13985 1.68863 8.32751 4.03977C9.01307 4.106 9.67481 4.25367 10.3029 4.47299L10.3045 4.46927C10.5055 3.98396 10.8001 3.54301 11.1716 3.17157C11.543 2.80014 11.984 2.5055 12.4693 2.30448C12.9546 2.10346 13.4747 2 14 2C14.4142 2 14.75 2.33579 14.75 2.75C14.75 3.16421 14.4142 3.5 14 3.5C13.6717 3.5 13.3466 3.56466 13.0433 3.6903C12.74 3.81594 12.4644 4.00009 12.2322 4.23223C12.0001 4.46438 11.8159 4.73998 11.6903 5.04329C11.6836 5.05943 11.6771 5.07563 11.6708 5.09188C14.0281 6.42191 15.687 8.84455 15.9602 11.6725ZM16.5 6C16.5 5.56116 16.3845 5.13005 16.1651 4.75C15.958 4.39128 16.0809 3.93259 16.4396 3.72548C16.7983 3.51837 17.257 3.64128 17.4641 4C17.8152 4.60808 18 5.29785 18 6C18 6.41421 17.6642 6.75 17.25 6.75C16.8358 6.75 16.5 6.41421 16.5 6Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1642_3272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAa);
export default __webpack_public_path__ + "static/media/açaí.e4265f2bd1691360f25b08a6d77ab626.svg";
export { ForwardRef as ReactComponent };